import logo from "../assests/Logo.png";
import leftArrow from "../assests/icons/left_arrow.png";
import addSquare from "../assests/icons/addSquare.png";
import calendar2 from "../assests/icons/calendar-2.png";
import calendar from "../assests/icons/calendar.png";
import edit from "../assests/icons/edit.png";
import equalTo from "../assests/icons/equalTo.png";
import filter from "../assests/icons/filter.png";
import lampOn from "../assests/icons/lamp-on.png"
import link from "../assests/icons/link.png";
import menu from "../assests/icons/menu.png";
import messageQuestion from "../assests/icons/message-question.png";
import message from "../assests/icons/message.png";
import notification from "../assests/icons/notification.png";
import profileUser from "../assests/icons/profile-2user.png";
import setting from "../assests/icons/setting-2.png";
import taskSquare from "../assests/icons/task-square.png";
import tripleDot from "../assests/icons/tripleDot.png";
import users from "../assests/icons/users.png";
import taskUsers from "../assests/icons/taskUsers.png"
import jinesh from "../assests/jinesh.png";

const images = {
    logo,
    leftArrow,
    addSquare,
    calendar2,
    calendar,
    edit,
    equalTo,
    filter,
    lampOn,
    link,
    menu,
    messageQuestion,
    message,
    notification,
    profileUser,
    setting,
    taskSquare,
    tripleDot,
    users,
    taskUsers,
    jinesh
}

export default images;